import React, { PureComponent } from 'react';
import * as R from 'ramda';
import { sessionService } from 'redux-react-session';
import { Form, Modal } from 'antd';
import axios from 'axios'
import Wizard from '../../components/wizard/wizard';
import Withdrawal from './withdrawal';
import BankAccount from './bankAccount';
import AccountVerification from './accountVerification';
import { withActions } from 'actionware';
import { getTranslate } from 'react-localize-redux';
import { toggleWithdrawalModal, createWithdrawal, setOtherForm } from './withdrawalActions';
import InlineSVG from 'react-inlinesvg';
import withdrawalSuccessIcon from '../../assets/withdrawal_success.svg';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import './withdrawal.less';
import { getConfig } from '../../common/config';

@withRouter
@connect(
  ({ localize, session: { user }, withdrawal: { showingWithdrawalModal, failedWithdrawal } }) => ({
    translate: getTranslate(localize),
    showingWithdrawalModal,
    user,
    failedWithdrawal
  })
)
@withActions({
  toggleWithdrawalModal,
  createWithdrawal,
  setOtherForm
})
@Form.create()
export default class WithdrawalModal extends PureComponent {
  state = { step: 1 };

  componentWillReceiveProps(nextProps) {
    if (
      nextProps.showingWithdrawalModal &&
      !this.props.showingWithdrawalModal
    ) {
      this.props.form.resetFields();
      this.setState({
        step: 1
      });
    }
  }

  validateFields = async (...fields) =>
    new Promise((resolve, reject) => {
      return this.props.form.validateFields(fields, (errors, values) => {
        const password = values.password
        if (password && password !== '') {
          const baseApi = getConfig('LENDER_API');
          return sessionService.loadSession().then((res) => {
            const authToken = res.authToken
            return axios.post(`${baseApi}/check-password`,
              { password },
              {
                headers: { Authorization: `Bearer ${authToken}` }
              })
              .then((res) => {
                return resolve(true)
              })
              .catch((err) => {
                return this.props.form.setFields({
                  password: {
                    value: password,
                    errors: [new Error("Wrong password")]
                  }
                })
              })
          })
        }
        else if (this.state.step === 3 && !password) {
          return this.props.form.setFields({
            password: {
              value: '',
              errors: [new Error("This field is required")]
            }
          })
        }
        return resolve(!errors)
      })
    });

  validateWithdrawal = async () =>
    this.validateFields('amount', 'amountConfirm');

  validateBankAccount = async () => {
    return this.validateFields('bankAccount', 'bank', 'bankAccountHolder', 'bankAccountNumber', 'branch', 'city');
  }


  validateAccountVerification = async () => this.validateFields('password');

  handleSubmit = () => {
    return this.validateAccountVerification().then((res) => {
      this.props.form.validateFields((errors, values) => {
        delete values.password
        delete values.amountConfirm

        const routeAccountId = R.path(['params', 'accountId'], this.props.match);
        const bankAccount = values.bankAccount
        const newData = Object.assign(values, { lenderAccountId: routeAccountId, bankAccountId: Number(bankAccount), userId: this.props.user.userId })
        return this.props.createWithdrawal(newData)
      })
    })
  };

  handleClose = () => {
    this.props.toggleWithdrawalModal();
    this.props.setOtherForm(false);
  }

  // This is called by the wizard component so we can
  // keep a reference of the current step
  syncStep = step => this.setState({ step });

  get title() {
    const { translate } = this.props;
    switch (this.state.step) {
      case 1:
        return translate('withdrawal.withdrawalTitle');
      case 2:
        return translate('withdrawal.bankTitle');
      case 3:
      default:
        return translate('withdrawal.accountVerificationTitle');
    }
  }

  render() {
    const {
      user,
      showingWithdrawalModal,
      failedWithdrawal,
      toggleWithdrawalModal,
      setOtherForm,
      translate,
      form
    } = this.props;

    return (
      <Modal
        className={'modal-form withdrawal-modal'}
        visible={showingWithdrawalModal}
        title={
          this.state.step < 4 ? (
            <div>
              <div className={'title'}>{this.title}</div>
              <div className={'subtitle'}>
                {translate('withdrawal.subtitle')}
              </div>
            </div>
          ) : null
        }
        onCancel={this.handleClose}
        width={570}
      >
        <Wizard currentStep={this.state.step} onChange={this.syncStep}>
          <Wizard.Step
            nextText={translate('withdrawal.continue')}
            beforeNext={this.validateWithdrawal}
          >
            <Withdrawal form={form} />
          </Wizard.Step>
          <Wizard.Step
            nextText={translate('withdrawal.continue')}
            beforeNext={this.validateBankAccount}
          >
            <BankAccount form={form} />
          </Wizard.Step>
          <Wizard.Step
            nextText={translate('withdrawal.requestWithdrawal')}
            beforeNext={this.handleSubmit}
          >
            <AccountVerification form={form} />
          </Wizard.Step>
          <Wizard.Step className={'withdrawal-success'}>
            <InlineSVG src={withdrawalSuccessIcon} className={'icon'} />
            <div>
              <h1>
                {translate('withdrawal.successOrFailedTitle', {
                  name: (user && user.name) || 'John'
                })}
              </h1>
              {translate(failedWithdrawal ? 'withdrawal.failedMessage' : 'withdrawal.successMessage')}
            </div>
          </Wizard.Step>
        </Wizard>
      </Modal>
    );
  }
}
